import {
  UPLOAD_PRODUCT_FAILED,
  UPLOAD_PRODUCT_SUCCESS,
  UPLOAD_PRODUCT_INVALID_REQUEST,
  UPLOAD_PRODUCT_NOT_FOUND,
  LOADING_UPLOAD_PRODUCT,
  RESET_UPLOAD_PRODUCT,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  status: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UPLOAD_PRODUCT:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        notFound: false,
        status: "",
      };

    case UPLOAD_PRODUCT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        notFound: false,
        status: "Upload Product Failed!",
      };

    case UPLOAD_PRODUCT_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        notFound: false,
        status: "Something went wrong!",
      };

    case UPLOAD_PRODUCT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        notFound: false,
        status: "Upload Product Success",
      };
    }

    case UPLOAD_PRODUCT_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: true,
        status: "Upload Product Not Found!",
      };

    case RESET_UPLOAD_PRODUCT:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: false,
        status: "",
      };

    default:
      return state;
  }
};
